import React, { useState, useRef, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { downloadAPK } from "../../Helpers/DownloadAPK";
import downloadbutton from "../../../RichImages/downloadbutton.svg";
// import headerLog from "../../../RichImages/Websitelogo12.png";
import headerLog from "../../../RichImages/newradhaLogo.png";
import homeicon from "../../../RichImages/homeicon.svg";
import charticon from "../../../RichImages/charts.svg";
import privacypolicy from "../../../RichImages/privacy.png";
import termandcodition from "../../../RichImages/term.png";
import downloadbuttonn from "../../../RichImages/downloadbuttonn.svg";
const Navbar = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const collapseRef = useRef(null);

  const handleClickOutside = (event) => {
    if (collapseRef.current && !collapseRef.current.contains(event.target)) {
      setIsCollapsed(true);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="app-container">
        <div className="banner-section">
          <div className="header-container">
            <nav className="navbar navbar-expand-lg">
              <div className="container-fluid header-content-main">
                <div style={{ marginTop: "5px" }}>
                  <Logo />
                </div>
                <button
                  class="navbar-toggler navbar-toggler-btn custom-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span class="navbar-toggler-icon"></span>
                </button>
                <div
                  className={`collapse navbar-collapse custome-nav  ${
                    isCollapsed ? "" : "show"
                  }`}
                  id="navbarSupportedContent"
                  ref={collapseRef}
                >
                  <div className="navigation-links"></div>

                  <div
                    className="navigation-links"
                    style={{ marginRight: "35px" }}
                  >
                    <NavigationLinks />
                  </div>

                  <div className="download-btn-main-12 ">
                    <DownloadButton />
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </>
  );
};

const Logo = () => {
  return (
    <>
      <Link className="nav-link  active" aria-current="page" to="/">
        <img
          className="logo_navbar"
          src={headerLog}
          alt="https://radha567.com/"
        />
      </Link>
    </>
  );
};

const NavigationLinks = () => {
  return (
    <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
      <li className="nav-item">
        <div className="nvbaralign">
          <img
            src={homeicon}
            className="navicons"
            alt="https://radha567.com/"
          />

          <Link className="nav-link hover-3" to="/">
            Home
          </Link>
        </div>
      </li>
      <li className="nav-item">
        <div className="nvbaralign">
          <img
            src={charticon}
            className="navicons"
            alt="https://radha567.com/"
          />

          <Link className="nav-link hover-3" to="/charts">
            Charts
          </Link>
        </div>
      </li>
      <li className="nav-item">
        <div className="nvbaralign">
          <img
            src={termandcodition}
            className="navicons"
            alt="https://radha567.com/"
            style={{ height: "22px", color: "white", marginTop: "5px" }}
          />

          <Link className="nav-link hover-3" to="/terms-conditions">
            Term&nbsp;and&nbsp;Condition
          </Link>
        </div>
      </li>
      <li className="nav-item">
        <div className="nvbaralign">
          <img
            src={privacypolicy}
            className="navicons"
            alt="https://radha567.com/"
            style={{ height: "20px", color: "white", marginTop: "5px" }}
          />

          <Link className="nav-link hover-3" to="/privacy-policy">
            Privacy&nbsp;Policy
          </Link>
        </div>
      </li>
    </ul>
  );
};

const download = async (e) => {
  e.preventDefault();

  const newTab = window.open("about:blank", "_blank");

  if (!newTab) {
    alert("Popup blocked! Please allow popups.");
    return;
  }

  // Only favicon loader (tab ke upar spinner)
  const loaderIcon =
    "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='40' stroke='%23999' stroke-width='8' fill='none' stroke-dasharray='180'><animateTransform attributeName='transform' type='rotate' from='0 50 50' to='360 50 50' dur='1s' repeatCount='indefinite'/></circle></svg>";

  try {
    // Empty page
    newTab.document.open();
    newTab.document.write("<html><head></head><body></body></html>");
    newTab.document.close();

    // Set favicon (THIS IS YOUR “EARTH ICON LOADER”)
    const link = newTab.document.createElement("link");
    link.rel = "icon";
    link.href = loaderIcon;
    newTab.document.head.appendChild(link);

    newTab.document.title = "Loading...";

    const url = await downloadAPK();

    if (!url) {
      newTab.close();
      return;
    }

    // start download (no redirect flicker)
    const a = document.createElement("a");
    a.href = url;
    a.download = "boss555.apk";
    document.body.appendChild(a);
    a.click();
    a.remove();

    setTimeout(() => {
      newTab.close();
    }, 1500);
  } catch (err) {
    newTab.close();
    console.error(err);
  }
};

const DownloadButton = () => {
  return (
    // <a href="#" id="BTTTTT" class="btn1">Download Now</a>
    <>
      {/* <button className="downloadBtn" onClick={download}>
        Download Now
      </button> */}

      {/* <div class="button-container_3"> */}
      <div>
        {/* <div class="button-container_2"> */}

        <div>
          <div class="button-container">
            {/* <button
              class="download-button test border"
              // onClick={download}
              // disabled
            >
              <span>Download App</span>
              &nbsp;
              <img
                className="test_image"
                src={downlooadicon}
                alt="https://radha567.com/"
              />
            </button> */}

            <img
              onClick={(e) => download(e)}
              className="da-download-btn"
              src={downloadbuttonn}
              alt="https://radha567.com/"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
